"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const colors_1 = require("../themes/colors");
const Link_1 = __importDefault(require("../Link"));
const ChevronRight_1 = __importDefault(require("../Icons/ChevronRight"));
const InformationSolid_1 = __importDefault(require("../Icons/InformationSolid"));
const LightBulb_1 = __importDefault(require("../Icons/LightBulb"));
const TriangleExclamation_1 = __importDefault(require("../Icons/TriangleExclamation"));
const styled_1 = require("./styled");
const Alert = (_a) => {
    var { design: style = 'info', href, newTab, icon, children } = _a, rest = __rest(_a, ["design", "href", "newTab", "icon", "children"]);
    const getContent = () => {
        switch (style) {
            case 'info':
                return (react_1.default.createElement(styled_1.AlertWrapper, Object.assign({ color: colors_1.colors.shade90, background: colors_1.colors.verseNavBlue }, rest),
                    icon || react_1.default.createElement(LightBulb_1.default, { fill: colors_1.colors.primaryBlue100 }),
                    children,
                    href && react_1.default.createElement(ChevronRight_1.default, { size: 15, color: colors_1.colors.primaryBlue100 })));
            case 'warning':
                return (react_1.default.createElement(styled_1.AlertWrapper, Object.assign({ color: colors_1.colors.shade90, background: colors_1.colors.yellow25 }, rest),
                    icon || react_1.default.createElement(InformationSolid_1.default, { fill: colors_1.colors.yellow100 }),
                    children,
                    href && react_1.default.createElement(ChevronRight_1.default, { size: 15, color: colors_1.colors.yellow100 })));
            case 'error':
            default:
                return (react_1.default.createElement(styled_1.AlertWrapper, Object.assign({ color: colors_1.colors.shade100, background: colors_1.colors.red25 }, rest),
                    icon || react_1.default.createElement(TriangleExclamation_1.default, { fill: colors_1.colors.red100 }),
                    children,
                    href && react_1.default.createElement(ChevronRight_1.default, { size: 15, color: "#FFFFFF" })));
        }
    };
    return href ? (react_1.default.createElement(Link_1.default, { href: href, newTab: newTab }, getContent())) : (react_1.default.createElement(react_1.default.Fragment, null, getContent()));
};
exports.default = Alert;
//# sourceMappingURL=Alert.js.map